module.exports = __webpack_public_path__ + "static/media/icon-placard-location-id-ja.538e89fb.png";